import React, {useEffect, useRef} from "react";
import {useDispatch} from "react-redux";
import {closeDialog} from "../../slices/dialog";
import ButtonCircle from "../Common/ButtonCircle";
import CloseIcon from "@material-ui/icons/Close";
import "./index.scss"

export const Dialog = ({title, Content, props, closable, topRef, narrow, subtitle}) => {
    const dispatch = useDispatch();
    const topDialogRef = useRef(null);

    useEffect(() => {
        // topRef.current.scrollIntoView();
    }, [])

    return (
        <div className={`dialog ${narrow ? "dialog-narrow" : ""}`}>
            <div className="card">
                <div className="dialog__header">
                    {title && <p className="dialog__headerText">{title}</p>}
                    {closable &&
                        <div className={'btn-z-index'}>
                            <ButtonCircle onClick={() => dispatch(closeDialog())}><CloseIcon/></ButtonCircle>
                        </div>
                    }
                </div>
                {subtitle && <p className="dialog__subtitle">{subtitle}</p>}

                <div className="dialog__content" ref={topDialogRef}>
                    <Content {...props} topRef={topRef} topDialogRef={topDialogRef}/>
                </div>
            </div>
        </div>
    );
};